module.exports = __webpack_public_path__ + "img/1.9167afc1.png";